import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../../services/apiAxios';
import helpers from '../../../mixins/helpers';
import axios from 'axios';
import moment from 'moment';

let requestIndicadorVentas = axios.CancelToken.source();

const state = {
    indicadorVentas: {},
    indicadorVentasTotal: {},
    indicadoresVentasHistorico: [],
    indicadoresVentasHistoricoTotal: [],
    indicadoresVentasAnualHistorico: [],
    indicadoresVentasAnualHistoricoTotal: [],
    
    indicadorVentasTrimestral: [],
    ventaMensualBase: [],
    ventaMensualBaseAnio: 1900,
    ventaMensual: [],
    ventaMensualAnio: 1900,
    
    indicadorVentasMixClientes: {},
    indicadorVentasTotalMixClientes: {},
    indicadoresVentasMixClientesHistorico: [],
    indicadoresVentasTotalMixClientesHistorico: [],
    indicadoresVentasMixClientesAnualHistorico: [],
    indicadoresVentasTotalMixClientesAnualHistorico: [],

    indicadoresVentasPGClientesHistorico: [],
    indicadoresVentasTotalPGClientesHistorico: [],

    resultados: []
};

const mutations = {
    updateField,

    'INICIALIZAR_INDICADORES_VENTAS' (state) {
        state.indicadorVentas = {};
        state.indicadorVentasMixClientes = {};
    },
    'INICIALIZAR_INDICADORES_VENTAS_TOTAL' (state) {
        state.indicadorVentasTotal = {};
        //state.indicadorVentasTotalMixClientes = {};
    },
    'INICIALIZAR_INDICADORES_VENTAS_TRIMESTRAL' (state) {
        state.indicadorVentasTrimestral = [];
        state.ventaMensualBase = [];
        state.ventaMensualBaseAnio = 1900;
        state.ventaMensual = [];
        state.ventaMensualAnio = 1900;
    },
    'INICIALIZAR_INDICADORES_VENTAS_HISTORICO' (state) {
        state.indicadoresVentasHistorico = [];
        state.indicadoresVentasHistoricoTotal = [];
        state.indicadoresVentasAnualHistorico = [];
        state.indicadoresVentasAnualHistoricoTotal = [];
        state.indicadoresVentasMixClientesHistorico = [];
        state.indicadoresVentasTotalMixClientesHistorico = [];
        state.indicadoresVentasMixClientesAnualHistorico = [];
        state.indicadoresVentasTotalMixClientesAnualHistorico = [];
        state.indicadoresVentasPGClientesHistorico = [];
        state.indicadoresVentasTotalPGClientesHistorico = [];
    },

    'SET_INDICADOR_VENTAS'(state, indicador) {
        state.indicadorVentas = indicador;
    },
    'SET_INDICADOR_VENTAS_TOTAL'(state, indicador) {
        state.indicadorVentasTotal = indicador;
    },

    'SET_INDICADORES_VENTAS_HISTORICO'(state, indicadores) {
        state.indicadoresVentasHistorico = indicadores;
    },
    'SET_INDICADORES_VENTAS_HISTORICO_TOTAL'(state, indicadores) {
        state.indicadoresVentasHistoricoTotal = indicadores;
    },
    'SET_INDICADORES_VENTAS_ANUAL_HISTORICO'(state, indicadores) {
        state.indicadoresVentasAnualHistorico = indicadores;
    },
    'SET_INDICADORES_VENTAS_ANUAL_HISTORICO_TOTAL'(state, indicadores) {
        state.indicadoresVentasAnualHistoricoTotal = indicadores;
    },

    'SET_INDICADOR_VENTAS_TRIMESTRAL'(state, indicador) {
        state.indicadorVentasTrimestral = indicador;
    },

    'SET_VENTA_MENSUAL_BASE'(state, ventaMensual) {
        state.ventaMensualBase = ventaMensual.map(venta => (
            {
                ...venta, 
                montoNetoReembolsos: parseFloat(venta.montoNeto) - parseFloat(venta.montoNetoSinReembolsos),
                totales: false,
                titulo: '',
                _rowVariant: ''
            }));
        
        /* Totales */
        let totalNeto = state.ventaMensualBase.reduce((total, periodo) => total + parseFloat(periodo.montoNeto), 0);
        let totalNetoSinReembolsos = state.ventaMensualBase.reduce((total, periodo) => total + parseFloat(periodo.montoNetoSinReembolsos), 0);
        
        state.ventaMensualBaseAnio = 1900;
        if (state.ventaMensualBase) {
            if (state.ventaMensualBase.length != 0) {
                state.ventaMensualBaseAnio = new Date(state.ventaMensualBase[0].fechaDesde).getFullYear();
            }
        }

        /* Primer semestre */
        let totalNetoPrimerSemestre = state.ventaMensualBase
            .reduce((total, periodoVentas) => {
                let mes = parseInt(moment(periodoVentas.periodo).format('MM'));    
                let monto = 0;
                
                if (mes <= 6) {
                    monto = parseFloat(periodoVentas.montoNeto);
                }

                return total + monto;
            }, 0);

        let totalNetoSinReembolsosPrimerSemestre = state.ventaMensualBase
            .reduce((total, periodoVentas) => {
                let mes = parseInt(moment(periodoVentas.periodo).format('MM'));    
                let monto = 0;
                
                if (mes <= 6) {
                    monto = parseFloat(periodoVentas.montoNetoSinReembolsos);
                }

                return total + monto;
            }, 0);

        /* Segundo semestre */
        let totalNetoSegundoSemestre = state.ventaMensualBase
            .reduce((total, periodoVentas) => {
                let mes = parseInt(moment(periodoVentas.periodo).format('MM'));    
                let monto = 0;
                
                if (mes >= 7) {
                    monto = parseFloat(periodoVentas.montoNeto);
                }

                return total + monto;
            }, 0);

        let totalNetoSinReembolsosSegundoSemestre = state.ventaMensualBase
            .reduce((total, periodoVentas) => {
                let mes = parseInt(moment(periodoVentas.periodo).format('MM'));    
                let monto = 0;
                
                if (mes >= 7) {
                    monto = parseFloat(periodoVentas.montoNetoSinReembolsos);
                }

                return total + monto;
            }, 0);

        /* Primer Semestre */
        state.ventaMensualBase.splice(6, 0, {
            montoNeto: totalNetoPrimerSemestre,
            montoNetoSinReembolsos: totalNetoSinReembolsosPrimerSemestre,
            montoNetoReembolsos: parseFloat(totalNetoPrimerSemestre) - parseFloat(totalNetoSinReembolsosPrimerSemestre),

            totales: true,
            titulo: '1er.Sem',
            _rowVariant: 'totales',
            fechaDesde: `${ state.ventaMensualBaseAnio.toString().trim() }-01-01`,
            fechaHasta: `${ state.ventaMensualBaseAnio.toString().trim() }-06-30`,
        });
        
        /* Segundo Semestre */
        state.ventaMensualBase.push({
            montoNeto: totalNetoSegundoSemestre,
            montoNetoSinReembolsos: totalNetoSinReembolsosSegundoSemestre,
            montoNetoReembolsos: parseFloat(totalNetoSegundoSemestre) - parseFloat(totalNetoSinReembolsosSegundoSemestre),

            totales: true,
            titulo: '2do.Sem',
            _rowVariant: 'totales',
            fechaDesde: `${ state.ventaMensualBaseAnio.toString().trim() }-07-01`,
            fechaHasta: `${ state.ventaMensualBaseAnio.toString().trim() }-12-31`,
        })

        /* Totales */
        state.ventaMensualBase.push({
            montoNeto: totalNeto,
            montoNetoSinReembolsos: totalNetoSinReembolsos,
            montoNetoReembolsos: parseFloat(totalNeto) - parseFloat(totalNetoSinReembolsos),
            totales: true,
            titulo: 'Totales',
            _rowVariant: 'totales',
            fechaDesde: `${ state.ventaMensualBaseAnio.toString().trim() }-01-01`,
            fechaHasta: `${ state.ventaMensualBaseAnio.toString().trim() }-12-31`,
        })
    },
    'SET_VENTA_MENSUAL'(state, ventaMensual) {
        state.ventaMensual = ventaMensual.map(venta => (
            {
                ...venta, 
                montoNetoReembolsos: parseFloat(venta.montoNeto) - parseFloat(venta.montoNetoSinReembolsos),
                totales: false,
                titulo: '',
                _rowVariant: ''
            }));
        
        /* Totales */
        let totalNeto = state.ventaMensual.reduce((total, periodo) => total + parseFloat(periodo.montoNeto), 0);
        let totalNetoSinReembolsos = state.ventaMensual.reduce((total, periodo) => total + parseFloat(periodo.montoNetoSinReembolsos), 0);

        state.ventaMensualAnio = 1900;
        if (state.ventaMensual) {
            if (state.ventaMensual.length != 0) {
                state.ventaMensualAnio = new Date(state.ventaMensual[0].fechaDesde).getFullYear();
            }
        }

        /* Primer semestre */
        let totalNetoPrimerSemestre = state.ventaMensual
            .reduce((total, periodoVentas) => {
                let mes = parseInt(moment(periodoVentas.periodo).format('MM'));    
                let monto = 0;
                if (mes <= 6) {
                    monto = parseFloat(periodoVentas.montoNeto);
                }
                return total + monto;
            }, 0);

        let totalNetoSinReembolsosPrimerSemestre = state.ventaMensual
            .reduce((total, periodoVentas) => {
                let mes = parseInt(moment(periodoVentas.periodo).format('MM'));    
                let monto = 0;
                
                if (mes <= 6) {
                    monto = parseFloat(periodoVentas.montoNetoSinReembolsos);
                }

                return total + monto;
            }, 0);

        /* Segundo semestre */
        let totalNetoSegundoSemestre = state.ventaMensual
            .reduce((total, periodoVentas) => {
                let mes = parseInt(moment(periodoVentas.periodo).format('MM'));    
                let monto = 0;
                
                if (mes >= 7) {
                    monto = parseFloat(periodoVentas.montoNeto);
                }

                return total + monto;
            }, 0);

        let totalNetoSinReembolsosSegundoSemestre = state.ventaMensual
            .reduce((total, periodoVentas) => {
                let mes = parseInt(moment(periodoVentas.periodo).format('MM'));    
                let monto = 0;
                
                if (mes >= 7) {
                    monto = parseFloat(periodoVentas.montoNetoSinReembolsos);
                }

                return total + monto;
            }, 0);

        /* Primer Semestre */
        state.ventaMensual.splice(6, 0, {
            montoNeto: totalNetoPrimerSemestre,
            montoNetoSinReembolsos: totalNetoSinReembolsosPrimerSemestre,
            montoNetoReembolsos: parseFloat(totalNetoPrimerSemestre) - parseFloat(totalNetoSinReembolsosPrimerSemestre),

            totales: true,
            titulo: '1er.Sem',
            _rowVariant: 'totales',
            fechaDesde: `${ state.ventaMensualAnio.toString().trim() }-01-01`,
            fechaHasta: `${ state.ventaMensualAnio.toString().trim() }-06-30`,
        });
        
        /* Segundo Semestre */
        state.ventaMensual.push({
            montoNeto: totalNetoSegundoSemestre,
            montoNetoSinReembolsos: totalNetoSinReembolsosSegundoSemestre,
            montoNetoReembolsos: parseFloat(totalNetoSegundoSemestre) - parseFloat(totalNetoSinReembolsosSegundoSemestre),

            totales: true,
            titulo: '2do.Sem',
            _rowVariant: 'totales',
            fechaDesde: `${ state.ventaMensualAnio.toString().trim() }-07-01`,
            fechaHasta: `${ state.ventaMensualAnio.toString().trim() }-12-31`,
        })

        /* Totales */
        state.ventaMensual.push({
            montoNeto: totalNeto,
            montoNetoSinReembolsos: totalNetoSinReembolsos,
            montoNetoReembolsos: parseFloat(totalNeto) - parseFloat(totalNetoSinReembolsos),

            totales: true,
            titulo: 'Totales',
            _rowVariant: 'totales',
            fechaDesde: `${ state.ventaMensualAnio.toString().trim() }-01-01`,
            fechaHasta: `${ state.ventaMensualAnio.toString().trim() }-12-31`
        })
    },

    'INICIALIZAR_RESULTADOS' (state) {
        state.resultados = [];
    },
    'SET_RESULTADOS'(state, resultados) {
        state.resultados = resultados;
    },
    'SET_INDICADOR_VENTAS_MIX_CLIENTES'(state, indicador) {
        state.indicadorVentasMixClientes = indicador;
    },
    'INICIALIZAR_INDICADOR_VENTAS_TOTAL_MIX_CLIENTES'(state) {
        state.indicadorVentasTotalMixClientes = [];
    },
    'SET_INDICADOR_VENTAS_TOTAL_MIX_CLIENTES'(state, indicador) {
        state.indicadorVentasTotalMixClientes = indicador;
    },
    'SET_INDICADORES_VENTAS_MIX_CLIENTES_HISTORICO'(state, indicadores) {
        state.indicadoresVentasMixClientesHistorico = indicadores;
    },
    'SET_INDICADORES_VENTAS_TOTAL_MIX_CLIENTES_HISTORICO'(state, indicadores) {
        state.indicadoresVentasTotalMixClientesHistorico = indicadores;
    },
    'SET_INDICADORES_VENTAS_MIX_CLIENTES_ANUAL_HISTORICO'(state, indicadores) {
        state.indicadoresVentasMixClientesAnualHistorico = indicadores;
    },
    'SET_INDICADORES_VENTAS_TOTAL_MIX_CLIENTES_ANUAL_HISTORICO'(state, indicadores) {
        state.indicadoresVentasTotalMixClientesAnualHistorico = indicadores;
    },

    'SET_INDICADORES_VENTAS_PG_CLIENTES_HISTORICO'(state, indicadores) {
        state.indicadoresVentasPGClientesHistorico = indicadores;
    },
    'SET_INDICADORES_VENTAS_TOTAL_PG_CLIENTES_HISTORICO'(state, indicadores) {
        state.indicadoresVentasTotalPGClientesHistorico = indicadores;
    },
};

const getters = {
    getField,

    indicadorVentas(state) {
        return state.indicadorVentas;
    },
    indicadorVentasTotal(state) {
        return state.indicadorVentasTotal;
    },
    indicadoresVentasHistorico(state) {
        return state.indicadoresVentasHistorico;
    },
    indicadoresVentasHistoricoTotal(state) {
        return state.indicadoresVentasHistoricoTotal;
    },
    indicadoresVentasAnualHistorico(state) {
        return state.indicadoresVentasAnualHistorico;
    },
    indicadoresVentasAnualHistoricoTotal(state) {
        return state.indicadoresVentasAnualHistoricoTotal;
    },

    indicadorVentasTrimestral(state) {
        return state.indicadorVentasTrimestral;
    },
    ventaMensual(state) {
        return state.ventaMensual;
    },
    ventaMensualAnio(state) {
        return state.ventaMensualAnio;
    },
    ventaMensualBase(state) {
        return state.ventaMensualBase;
    },
    ventaMensualBaseAnio(state) {
        return state.ventaMensualBaseAnio;
    },
    indicadorVentasTrimestre1(state) {
        return getIndicadorTrimestre(state, 1);
    },
    indicadorVentasTrimestre2(state) {
        return getIndicadorTrimestre(state, 2);
    },
    indicadorVentasTrimestre3(state) {
        return getIndicadorTrimestre(state, 3);
    },
    indicadorVentasTrimestre4(state) {
        return getIndicadorTrimestre(state, 4);
    },

    indicadorVentasMixClientes(state) {
        return state.indicadorVentasMixClientes;
    },
    indicadorVentasTotalMixClientes(state) {
        return state.indicadorVentasTotalMixClientes;
    },
    indicadoresVentasMixClientesHistorico(state) {
        return state.indicadoresVentasMixClientesHistorico;
    },
    indicadoresVentasTotalMixClientesHistorico(state) {
        return state.indicadoresVentasTotalMixClientesHistorico;
    },
    indicadoresVentasMixClientesAnualHistorico(state) {
        return state.indicadoresVentasMixClientesAnualHistorico;
    },
    indicadoresVentasTotalMixClientesAnualHistorico(state) {
        return state.indicadoresVentasTotalMixClientesAnualHistorico;
    },

    indicadoresVentasPGClientesHistorico(state) {
        return state.indicadoresVentasPGClientesHistorico;
    },
    indicadoresVentasTotalPGClientesHistorico(state) {
        return state.indicadoresVentasTotalPGClientesHistorico;
    },

    resultados(state) {
        return state.resultados;
    },
};

function getIndicadorTrimestre(state, trimestre) {
    // console.log(state.indicadorVentasTrimestral);
    let indicador = [];
    let nombre = '';
    let anio = '';
    
    if (state.indicadorVentasTrimestral.length != 0) {
        anio = state.indicadorVentasTrimestral[trimestre - 1].anio.toString();
        switch(trimestre) {
            case 1:
                nombre = `1er Trimestre - ${anio}`;
                break;
            case 2:
                nombre = `2do Trimestre - ${anio}`;
                break;
            case 3:
                nombre = `3er Trimestre - ${anio}`;
                break;
            case 4:
                nombre = `4to Trimestre - ${anio}`;
                break;
        }
    
        // indicador.push({ campo: 'Período', valor: nombre, formato: ''});
        indicador.push({ campo: nombre.trim(), valor: '', formato: ''});
        indicador.push({ campo: 'Base Facturación', valor: state.indicadorVentasTrimestral[trimestre - 1].montoBase, formato: 'moneda' });
        indicador.push({ campo: 'Pje Inflación', valor: state.indicadorVentasTrimestral[trimestre - 1].pjeInflacion, formato: 'porcentaje' });
        indicador.push({ campo: 'Base Ajustada', valor: state.indicadorVentasTrimestral[trimestre - 1].montoBaseAjustado, formato: 'moneda' });
        indicador.push({ campo: 'Pje Crecimiento', valor: state.indicadorVentasTrimestral[trimestre - 1].pjeIncrementoObjetivo, formato: 'porcentaje'});
        indicador.push({ campo: 'Monto Objetivo', valor: state.indicadorVentasTrimestral[trimestre - 1].montoObjetivo, formato: 'moneda'});
        indicador.push({ campo: 'Monto Actual', valor: state.indicadorVentasTrimestral[trimestre - 1].montoActual, formato: 'moneda'});
        indicador.push({ campo: 'Pje Objetivo', valor: state.indicadorVentasTrimestral[trimestre - 1].pjeActualObjetivo, formato: 'porcentaje'});
    } else {
        switch(trimestre) {
            case 1:
                nombre = `1er Trimestre`;
                break;
            case 2:
                nombre = `2do Trimestre`;
                break;
            case 3:
                nombre = `3er Trimestre`;
                break;
            case 4:
                nombre = `4to Trimestre`;
                break;
        }
    
        indicador.push({ campo: nombre.trim(), valor: '', formato: ''});
        indicador.push({ campo: 'Base Facturación', valor: 0, formato: 'moneda' });
        indicador.push({ campo: 'Pje Inflación', valor: 0, formato: 'porcentaje' });
        indicador.push({ campo: 'Base Ajustada', valor: 0, formato: 'moneda' });
        indicador.push({ campo: 'Pje Crecimiento', valor: 0, formato: 'porcentaje'});
        indicador.push({ campo: 'Monto Objetivo', valor: 0, formato: 'moneda'});
        indicador.push({ campo: 'Monto Actual', valor: 0, formato: 'moneda'});
        indicador.push({ campo: 'Pje Objetivo', valor: 0, formato: 'porcentaje'});
    }
    
    return indicador;
}

const actions = {
    inicializarVentas ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES_VENTAS');
            resolve();
        })
    },
    getIndicadorVentas ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/ventas', { cancelToken: requestIndicadorVentas.token })
                .then(res => {
                    commit('SET_INDICADOR_VENTAS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    cancelar() {
        requestIndicadorVentas.cancel('getIndicadorVentas - Cancelado');
        requestIndicadorVentas = axios.CancelToken.source();
    },
    getIndicadorVentasMixClientes ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/ventas/mix-clientes')
                .then(res => {
                    commit('SET_INDICADOR_VENTAS_MIX_CLIENTES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    inicializarVentasTotal ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES_VENTAS_TOTAL');
            resolve();
        })
    },
    getIndicadorVentasTotal ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES_VENTAS_TOTAL');

            apiAxios.get('indicadores/ventas/total')
                .then(res => {
                    commit('SET_INDICADOR_VENTAS_TOTAL', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadorVentasTotalMixClientes ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADOR_VENTAS_TOTAL_MIX_CLIENTES');
            
            apiAxios.get('indicadores/ventas/mix-clientes/total')
                .then(res => {
                    commit('SET_INDICADOR_VENTAS_TOTAL_MIX_CLIENTES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    inicializarVentasHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES_VENTAS_HISTORICO');
            resolve();
        })
    },
    getIndicadoresVentasHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/ventas/historico')
                .then(res => {
                    commit('SET_INDICADORES_VENTAS_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadoresVentasHistoricoTotal ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/ventas/historico/total')
                .then(res => {
                    commit('SET_INDICADORES_VENTAS_HISTORICO_TOTAL', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadoresVentasAnualHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/ventas/anual/historico')
                .then(res => {
                    commit('SET_INDICADORES_VENTAS_ANUAL_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadoresVentasAnualHistoricoTotal ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/ventas/anual/historico/total')
                .then(res => {
                    commit('SET_INDICADORES_VENTAS_ANUAL_HISTORICO_TOTAL', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadoresVentasMixClientesHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/ventas/mix-clientes/historico')
                .then(res => {
                    commit('SET_INDICADORES_VENTAS_MIX_CLIENTES_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadoresVentasTotalMixClientesHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/ventas/mix-clientes/historico/total')
                .then(res => {
                    commit('SET_INDICADORES_VENTAS_TOTAL_MIX_CLIENTES_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadoresVentasMixClientesAnualHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/ventas/mix-clientes/anual/historico')
                .then(res => {
                    commit('SET_INDICADORES_VENTAS_MIX_CLIENTES_ANUAL_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadoresVentasTotalMixClientesAnualHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/ventas/mix-clientes/anual/historico/total')
                .then(res => {
                    commit('SET_INDICADORES_VENTAS_TOTAL_MIX_CLIENTES_ANUAL_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadoresVentasPGClientesHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/ventas/pg-clientes/historico')
                .then(res => {
                    commit('SET_INDICADORES_VENTAS_PG_CLIENTES_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadoresVentasTotalPGClientesHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/ventas/pg-clientes/historico/total')
                .then(res => {
                    commit('SET_INDICADORES_VENTAS_TOTAL_PG_CLIENTES_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    inicializarVentasTrimestral ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES_VENTAS_TRIMESTRAL');
            resolve();
        })
    },
    getIndicadorVentasTrimestral ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/ventas/trimestral')
                .then(res => {
                    commit('SET_INDICADOR_VENTAS_TRIMESTRAL', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getVentaMensual ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/ventas/mensual')
                .then(res => {
                    commit('SET_VENTA_MENSUAL', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getVentaMensualBase ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/ventas/mensual/base')
                .then(res => {
                    commit('SET_VENTA_MENSUAL_BASE', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    
    getIndicadorVentasComprobantes ( { commit } ) {
        commit('INICIALIZAR_RESULTADOS');

        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/ventas/comprobantes')
                .then(res => {
                    commit('SET_RESULTADOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadorVentasComprobantesExcluidos ( { commit } ) {
        commit('INICIALIZAR_RESULTADOS');

        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/ventas/excluidos')
                .then(res => {
                    commit('SET_RESULTADOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadorVentasHistoricoComprobantes ( { commit }, params ) {
        commit('INICIALIZAR_RESULTADOS');

        let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
            + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/ventas/historico/comprobantes' + query)
                .then(res => {
                    commit('SET_RESULTADOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getRptVentaMensual ( { commit }, params ) {
        commit('INICIALIZAR_RESULTADOS');

        let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
            + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/ventas/mensual/periodo' + query)
                .then(res => {
                    commit('SET_RESULTADOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getComprasByVentaMensual ( { commit }, params ) {
        commit('INICIALIZAR_RESULTADOS');

        let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
            + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/ventas/mensual/periodo/compras' + query)
                .then(res => {
                    commit('SET_RESULTADOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getRptVentaMensualCliente ( { commit }, params ) {
        commit('INICIALIZAR_RESULTADOS');

        let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
            + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

        return new Promise((resolve, reject) => {
            apiAxios.get(`indicadores/ventas/mensual/clientes/${params.clienteId}/periodo` + query)
                .then(res => {
                    commit('SET_RESULTADOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    actualizarMontoVentasReembolsos ( {} ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('indicadores/ventas/actualizar')
                .then(res => {
                    if (res.status == 200) {
                        resolve();
                    } else {
                        reject('No se pudo actualizar la información del indicador')
                    }
                })
                .catch(() => reject('No se pudo actualizar la información del indicador'));
                // .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}